export type PlaqueClass = "milestone" | "skill" | "secret";
export type Plaque = {
  id: string;
  name: string;
  class: PlaqueClass;
  how: string;
};

/* 36 plaques, no EN/SV duplicates. Milestones show a progress bar toward a
   known goal; skills are performance-gated; secrets stay a silhouette with
   "???" until earned. Predicates that check these live in engine/plaques.ts
   (Phase 3) — this file is metadata only. */
export const PLAQUES: Plaque[] = [
  // ---- Milestone (16) ----
  { id: "sessions-1", name: "First Session", class: "milestone", how: "Complete your first session" },
  { id: "sessions-10", name: "Ten Sessions", class: "milestone", how: "Complete 10 sessions" },
  { id: "sessions-50", name: "Fifty Sessions", class: "milestone", how: "Complete 50 sessions" },
  { id: "sessions-100", name: "Century", class: "milestone", how: "Complete 100 sessions" },
  { id: "sessions-365", name: "Full Year", class: "milestone", how: "Complete 365 sessions" },
  { id: "streak-3", name: "Three in a Row", class: "milestone", how: "Reach a 3-day streak" },
  { id: "streak-7", name: "Seven Suns", class: "milestone", how: "Reach a 7-day streak" },
  { id: "streak-30", name: "Iron Tongue", class: "milestone", how: "Reach a 30-day streak" },
  { id: "streak-100", name: "Unbroken", class: "milestone", how: "Reach a 100-day streak" },
  { id: "streak-365", name: "The Long Voice", class: "milestone", how: "Reach a 365-day streak" },
  { id: "minutes-60", name: "One Hour In", class: "milestone", how: "Train for 60 minutes total" },
  { id: "minutes-300", name: "Five Hours In", class: "milestone", how: "Train for 300 minutes total" },
  { id: "minutes-1000", name: "A Thousand Minutes", class: "milestone", how: "Train for 1000 minutes total" },
  { id: "rank-5", name: "Rising Voice", class: "milestone", how: "Reach Rank 5 — Projection" },
  { id: "rank-9", name: "Orator", class: "milestone", how: "Reach Rank 9 — Orator" },
  { id: "rank-12", name: "Golden Voice", class: "milestone", how: "Reach Rank 12 — Golden Voice" },

  // ---- Skill (12) ----
  { id: "phonation-25", name: "Deep Lungs", class: "skill", how: "Hold 25 seconds of steady phonation in one breath" },
  { id: "full-speed-first-try", name: "First Take", class: "skill", how: "Clear a Level-3 twister at full speed on your very first pass" },
  { id: "rhythm-95", name: "On the Beat", class: "skill", how: "Score 95%+ plosive timing accuracy in Syllable Explosions" },
  { id: "sound-map-8", name: "Eight Sounds", class: "skill", how: "Bring 8 phonemes to Mastery 5 on the Sound Map" },
  { id: "long-memory", name: "Long Memory", class: "skill", how: "Carry 30 cards past a 60-day review interval" },
  { id: "two-tongues", name: "Two Tongues", class: "skill", how: "Master at least one card in both English and Swedish" },
  { id: "clean-sweep", name: "Clean Sweep", class: "skill", how: "Finish a full session with every item graded Easy" },
  { id: "wpm-200", name: "Blistering", class: "skill", how: "Clear any twister at 200 wpm or faster" },
  { id: "steady-90", name: "Rock Steady", class: "skill", how: "Score 90%+ steadiness on a sustained vowel" },
  { id: "silver-tongue-en", name: "Silver Tongue", class: "skill", how: "Master 15 English tongue twisters" },
  { id: "guldtunga", name: "Guldtunga", class: "skill", how: "Master 15 Swedish tongue twisters" },
  { id: "fluent-one-lang", name: "Fluent", class: "skill", how: "Master every phrase in one language" },

  // ---- Secret (8) — hidden until earned ----
  { id: "dawn-patrol", name: "Dawn Patrol", class: "secret", how: "Complete a session before 6am" },
  { id: "night-shift", name: "Night Shift", class: "secret", how: "Complete a session after 11pm" },
  { id: "bilingual-week", name: "Bilingual Week", class: "secret", how: "Train in both languages every day for 7 straight days" },
  { id: "vendetta", name: "Vendetta", class: "secret", how: "Master a card you'd previously lapsed twice" },
  { id: "one-take", name: "One Take", class: "secret", how: "Clear a full session, every item 95%+, with zero retries" },
  { id: "comeback", name: "Comeback", class: "secret", how: "Return after 14+ days away and complete a session" },
  { id: "polyglot-perfect", name: "Polyglot Perfect", class: "secret", how: "Play a Polyglot daily card clean, start to finish" },
  { id: "tongue-twister", name: "Tongue Twister", class: "secret", how: "Master five Level-3 twisters in a single week" },
];
